const en_master_payment_method = {
    "": "payment method",
    name: "payment method name",
    time: "term (days)",
    add: "add payment method",
    edit: "edit payment method",

    error: {
        create: "Failed to create payment method.",
        delete: "Failed to delete payment method.",
        edit: "Failed to update payment method.",
        time: "Term (days) cannot be empty.",
    },

    success: {
        create: "Payment method created successfully.",
        delete: "Payment method deleted successfully.",
        edit: "Payment method updated successfully.",
    }
}

export default en_master_payment_method;